import { render, staticRenderFns } from "./activity-detail.vue?vue&type=template&id=19e3251a&scoped=true"
import script from "./activity-detail.vue?vue&type=script&lang=js"
export * from "./activity-detail.vue?vue&type=script&lang=js"
import style0 from "./activity-detail.vue?vue&type=style&index=0&id=19e3251a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3251a",
  null
  
)

export default component.exports